var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('fieldset',{staticClass:"basicInformation"},[_c('legend',{staticClass:"basicInformation-border"},[_vm._v(_vm._s(_vm.title))])]):_c('fieldset',{staticClass:"basicInformation"})])
}
var staticRenderFns = []

export { render, staticRenderFns }